<template>
  <div class="page-container city-choose">
    <ucar-title type="model" @close="close" ref="header">选择政治面貌</ucar-title>
    <div class="city-choose-header" ref="currentCity" v-if="value.name" @click="close">当前选择政治面貌：{{value.name}}</div>
    <div>
      <ul class="cities-group-list">
        <li class="" v-for="item in list" :key="item.name" @click="choose(item)">{{item.name}}</li>
      </ul>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
@import "../styles/variable.styl";

.city-choose {
  position: fixed;
  text-align: left;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  height: 100%;
  z-index: 999;
  display: flex;
  flex-flow: column nowrap;

  ul.cities-group-list {
    padding-left: 30px;
    background-color: #fff;

    li {
      height: 88px;
      line-height: 84px;
      color: $ucar_font_color;
      font-size: $ucar_font_h4;

      &:last-child {
        border-bottom: none;
      }
    }
  }
  .city-choose-wrapper {
    flex: 1 1 0;
    overflow: hidden;
    touch-action: none;
  }

  .city-choose-header {
    height: 88px;
    line-height: 84px;
    padding: 0 30px;
    color: $ucar_font_color;
    font-size: $ucar_font_h4;
  }

  ul.city-choose-slider {
    padding: 0;
    list-style: none;
    position: absolute;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    top: 0;
    bottom: 0;
    right: 0;
    width: 50px;
    color: $ucar_main_color;
    font-size: $ucar_font_h6;
    z-index: 1000;

    li {
      white-space: nowrap;
      font-size: $ucar_font_h6;
      line-height: 35px;
      height: 35px;
      color: $ucar_main_color;

      &.hot {
        font-size: 14px;
      }
    }
  }

  .city-choose-body {
    position: relative;
    padding-right: 50px;

    .hot-cities {
      background-color: $ucar_body_bg;
      color: $ucar_font_color;
      padding: 30px 0 0 30px;

      .hot-cities-title {
        padding: 20px 0;
        background-color: $ucar_body_bg;
        color: $ucar_alert_color;
        font-size: $ucar_font_h5;
        line-height: $ucar_font_h5;
      }

      ul.hot-cities-body {
        list-style: none;
        padding: 0;

        li {
          display: inline-block;
          border: 1px solid $ucar_light_border; /*no*/
          background-color: #fff;
          height: 88px;
          width: 196px;
          text-align: center;
          line-height: 84px;
          font-size: $ucar_font_h4;
          margin: 0 20px 20px 0;
        }
      }
    }

    .cities-group {
      .cities-group-title {
        line-height: $ucar_font_h5;
        background-color: $ucar_body_bg;
        color: $ucar_alert_color;
        padding: 20px 0 20px 30px;
        font-size: $ucar_font_h5;
      }


    }
  }
}
</style>

<script>
import Iscroll from 'iscroll'
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      currentIndex: ''
    }
  },
  directives: {
    scroll: {
      inserted (el, binding, vnode) {
        vnode.scroll = new Iscroll(el, {
          click: true
        })
      },
      componentUpdated (el, binding, vnode, oldVnode) {
        vnode.scroll = oldVnode.scroll
        vnode.scroll.refresh()
        if (binding.value && binding.value !== vnode.scroll.scrollPosition) {
          vnode.scroll.scrollToElement(`[id="${binding.value}"]`, 300)
          vnode.scroll.scrollPosition = binding.value
        }
      },
      unbind (el, binding, vnode, oldVnode) {
        vnode.scroll = oldVnode.scroll
        vnode.scroll.destroy()
        vnode.scroll = null
      }
    }
  },
  computed: {
    flags () {
      return this.list.map(item => item.flag)
    }
  },
  methods: {
    jump (flag) {
      this.currentIndex = flag
    },
    choose (val) {
      this.$emit('change', val)
    },
    close () {
      this.$emit('change')
    }
  }
}
</script>
